export const iconInputImages = {
  email: 'iconLetter' as 'iconLetter',
  password: 'iconLock' as 'iconLock',
  company: 'iconDocument' as 'iconDocument',
  user: 'iconPerson' as 'iconPerson',
  message: 'iconBubble' as 'iconBubble',
  phone: 'iconPhone' as 'iconPhone',
};
